module.exports = __webpack_public_path__ + "static/media/company-logo-small.446a6129.png";